export const useGeneralBlock = () => {
  const shouldIgnoreWholeLinkClick = (eventTarget: EventTarget | null): boolean => {
    return eventTarget instanceof HTMLElement && eventTarget.closest('.block-flag-label') !== null;
  }

  const makeClickable = (element: HTMLElement | null): void => {
    let link = element?.querySelector("a") as HTMLAnchorElement;
    window.location.href = link.getAttribute('href') as string;
  }
  
  // Add anchor link click event listeners to the whole block if whole link is active
  (document.querySelectorAll('.general-block__content--whole-link') as NodeListOf<HTMLElement>).forEach((generalBlockElement) => {
    generalBlockElement.addEventListener('click', (event) => {
      if (shouldIgnoreWholeLinkClick(event.target)) {
        return;
      }

      makeClickable(generalBlockElement);
    });
    generalBlockElement.addEventListener('keyup', (event) => {
      if (event?.key === 'Enter') {
        makeClickable(generalBlockElement);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', useGeneralBlock);
